import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// Import version from package.json
const version = process.env.REACT_APP_VERSION || "1.0.0";

const Login: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [timestampExpired, setTimestampExpired] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email || !password) {
      setError("Please enter both email and password");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const result = await login(email, password);
      // Role-based redirect after login
      const userRole = result?.user?.role;

      switch (userRole) {
        case "reviewer":
          navigate("/cms/dashboard");
          break;
        case "editor":
          navigate("/cms/dashboard");
          break;
        case "editor-reviewer":
          navigate("/cms/dashboard");
          break;
        case "admin":
        case "superadmin":
        default:
          navigate("/cms/dashboard");
          break;
      }
    } catch (err: any) {
      // Check if it's a timestamp expiration error
      if (err.response?.status === 401 && err.response?.data?.timestampExpired) {
        setTimestampExpired(true);
        setError(
          err.response?.data?.message ||
            "Session has expired. Please close the Desktop App and open it again."
        );
      } else {
        setError(
          err.response?.data?.message ||
            "Failed to login. Please check your credentials."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-form-container">
        <h1>Satsang Assistant - CMS</h1>

        {timestampExpired ? (
          <div className="error-message" style={{ 
            textAlign: 'center', 
            padding: '20px',
            fontSize: '16px',
            lineHeight: '1.6'
          }}>
            {error}
          </div>
        ) : (
          <>
            {error && <div className="error-message">{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  required
                />
              </div>

              <button type="submit" className="login-button" disabled={loading}>
                {loading ? "Logging in..." : "Login"}
              </button>
            </form>
          </>
        )}

        <div className="version-info">
          <span>Version {version}</span>
        </div>
      </div>
    </div>
  );
};

export default Login;
